export default __webpack_public_path__ + "static/media/card-project3.7d5e2513.png";